/**
 * Startup Module
 *
 * This module provides a standardized way to initialize and start API servers
 * with all common functionality like database connections, authentication,
 * health checks, documentation, and more.
 */

// Main server function
export { startServer } from './server';

// Configuration functions
export { initializeConfig } from './config';

// Database functions
export {
  initializeDatabase,
  closeDatabase,
  getCurrentDatabaseConnection
} from './database';

// Health check functions
export { setupHealthChecks } from './health';

// Documentation functions
export {
  setupDocumentation,
  setupSwagger,
  setupRedoc
} from './documentation';

// Lifecycle hook functions
export {
  executeBeforeInit,
  executeAfterConfigLoaded,
  executeAfterApiCreated,
  executeAfterDatabaseInit,
  executeAfterRoutesSetup,
  executeBeforeServerStart,
  executeAfterServerStart,
  executeBeforeShutdown,
  executeAfterDatabaseClosed,
  executeAfterServerClosed
} from './hooks';


// Re-export health functionality from @unidev-hub/health
export {
  // Core health components
  Status,
  HealthService,

  // Health indicators
  MemoryHealthIndicator,
  DiskHealthIndicator,
  HttpHealthIndicator,
  DatabaseHealthIndicator,

  // Middleware and endpoints
  createHealthEndpoint,

  // New history tracking
  HealthHistoryService
} from '@unidev-hub/health';

// Re-export health types
export type {
  HealthIndicator,
  HealthResult,
  HealthHistoryOptions,
  HealthHistoryRecord,
  EnhancedHealthEndpointOptions,
  HealthDashboardProps
} from '@unidev-hub/health';
